import React from 'react';
import GlobeChartGlobe from './GlobeChartGlobe.jsx';
import SizeGiver from '../../../containers/SizeGiver/SizeGiver.jsx';




class GlobeChart extends React.Component {
    getGradientStyle() {
        return {
            background: "linear-gradient(to right,"+this.props.gradient+ ")"
        }
    }
    getGradientWidget() {
        return <div style={{textAlign:"center", display:"table", marginTop:"10px"}}>
            <span style={{display:"table-cell", whiteSpace: "nowrap"}}>Low Traffic</span>
            <span style={{
                        width: "100%",
                        display: "table-cell",
                        paddingLeft:"5px",
                        paddingRight:"5px"
                    }}>
                <span style={Object.assign({},this.getGradientStyle(),{
                        width: "100%",
                        height: "20px",
                        display: "inline-block",
                        verticalAlign:"middle"
                    })}></span>
            </span>
            <span style={{display:"table-cell", whiteSpace: "nowrap"}}>High Traffic</span>
        </div>  
    }
    getGlobe() {
        if(this.props.flat) {
            return <img style={{width:"100%"}} src={this.props.texture}/>    
        } else {
            return <SizeGiver>
                <GlobeChartGlobe
                    texture={this.props.texture} 
                    startRotation={-200}/>
            </SizeGiver> 
        }
    }
    render() {
        return <div style={{width:"100%"}}>
            <div style={{cursor:"pointer",position:"relative"}}>
                {this.getGlobe()}
                <div className="globeshadow" style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    zIndex: -1,
                    borderRadius: "999999px",
                    boxShadow: "0 0 6px rgba(0,0,0,0.7)",
                    top:0  
                    }}/>
            </div>
            {this.props.legend}
        </div>
        
    }
}



export default GlobeChart;


// WEBPACK FOOTER //
// ./src/js/components/special/GlobeChart/GlobeChart.jsx